import { ListGroupItem } from "components/Shared";
import { translate } from "lib";
import _ from "lodash";
import React, { memo } from "react";

/**
 * One lease in the Leases list, built on the shared `ListGroupItem` — the same
 * component the property's Tenancies and Tenants tabs use, so the three lists
 * are the same object on screen.
 *
 * ---------------------------------------------------------------------------
 * TCODE AND TENANT ONLY. NO DATAPOINT COLUMNS.
 * ---------------------------------------------------------------------------
 * Lease Status, Current Amendment, Term in Force and Units were columns here and
 * came out (Sim, 24 Aug). None of them is what you scan a lease list for — the
 * TCode is — and all four are on the lease's own page: the term, the current
 * amendment and the unit count in the header datapoints, the status in the
 * Details tab. Adding a column back means adding a `datapoints` entry; mind the
 * note in `ListGroupItem` that a datapoint key doubles as a CSS class.
 *
 * NO STAMP ICON either: `ListGroupItem` renders the `.stamp` block only when an
 * `icon` prop is passed, and none is. (The PAGE HEADER does carry one — see the
 * `icons` map in lib/index.js.)
 *
 * The whole row is the link. A lease is opened, never edited from here:
 * `/lease_data` is the only writer of this record.
 */
const Row = ({ agreement }: { agreement: tcpinpoint.LeaseAgreement }) => {
	const heading = agreement.tcode || (translate("lease_agreement") as string);
	const subheading = _.compact([
		agreement.tenant_name,
		!!agreement.property_name ? `at ${agreement.property_name}` : null
	]).join(" ");

	return (
		<ListGroupItem
			id={agreement.id}
			link={`/lease-agreements/${agreement.id}`}
			heading={heading}
			subheading={subheading}
			// The amendment whose term is in force has been called off — the one row
			// in this list worth chasing. Carried as a class rather than a column so
			// it can be styled without reinstating the datapoints.
			className={!!agreement.cancelled_amendment ? "lease-agreement-cancelled" : ""}
		/>
	);
};

export default memo(Row);
